import { http } from "../core";
import { URL } from "./_url";
import { StatusCode } from "../constant";
import { ElevationResponse } from '@/types/elevations';

export const apiFetchElevationDetails = async (
  areaCode: string,
  neighborhoodCode: string,
  planCode: string
): Promise<ElevationResponse> => {
  const response = await http.get(URL.FETCH_ELEVATIONS_DATA(areaCode, neighborhoodCode, planCode));
  
  if (!response || response.status >= StatusCode.BADREQUEST) {
    throw new Error(String(response?.status ?? 'Unknown error'));
  }

  return response as ElevationResponse;
};
